<template>
    <div class="contentMain">
      <div class="content">
        <img src="../../assets/construction.png" style="width: 500px;height: 500px;text-align: center;" alt="">
        <div class="text">建设中</div>
      </div>
    </div>
  </template>
  
  <script>
  import { chileType, selArticleByType, getArticle } from "@/api/main";
  import QRCode from "qrcodejs2";
  export default {
    name: "Content",
    props: {
      tabsTypeName: String,
      tabsTypeId: String,
    },
    data() {
      return {
        contentType: "list",
        typeId: "",
        typeName: "",
        pageNum: 1,
        totalNum: 0,
        firList: [],
        firSelect: 0,
        secList: [],
        article: {},
        articleInfo: {},
        config: {
          url: '',
          sites: ["weibo", "qq", "qzone"],
          wechatQrcodeTitle: "微信扫一扫",
          wechatQrcodeHelper: "<p>扫一扫分享至朋友圈</p>",
        },
      };
    },
    mounted() {
      this.typeId = this.$route.query.typeId;
      this.typeName = this.$route.query.type;
      // if (this.$route.params.type) {
      //   this.typeId = this.$route.params.typeId;
      //   this.typeName = this.$route.params.type;
      // }
      this.getInfo();
      if (this.$route.query.articleId) {
        this.detail(this.$route.query.articleId);
      }
    },
    watch: {
      tabsTypeId: function(val) {
        if (val) {
          this.contentType = "list";
          this.typeId = val;
          this.pageNum = 1;
          this.getInfo();
        }
      },
      tabsTypeName: function(val) {
        if (val) {
          this.typeName = val;
        }
      },
      contentType: function(val) {
        if (val == 'list') {
          document.title = this.typeName
        }
      }
    },
    methods: {
      close(){
        window.opener=null;
        window.open('','_self');
        window.close();
      },
      qrcode() {
        document.getElementById("qrcode").innerHTML = ""; //清除上一次生成的二维码，防止刷新生成多个二维码
        this.config.url = ''
        var url = window.location.href
        // targetUrl = "http://qr.liantu.com/api.php?text=" + encodePath;
        this.config.url = url
        let qrcode = new QRCode("qrcode", {
          width: 160, //二维码宽度
          height: 160, //二维码高度
          text: url, // 二维码内容
          colorDark: "#000",
          colorLight: "#fff",
        });
      },
      getInfo() {
        var data = {
          typeId: this.typeId,
        };
        if (this.tabsTypeId) {
          data.typeId = this.$route.query.typeId;
        }
        chileType(data).then((resp) => {
          this.firList = resp.data;
          this.firListClick(0);
        });
      },
      firListClick(index) {
        this.firSelect = index;
        var data = {
          typeId: this.firList[index].id,
          page: this.pageNum - 1,
          size: 15,
        };
        selArticleByType(data).then((resp) => {
          this.totalNum = resp.data.totalElements;
          this.secList = resp.data.content;
        });
      },
      pageChange(num) {
        // console.log(num)
        this.pageNum = num;
        this.firListClick(this.firSelect);
      },
      print() {
        this.$print(this.$refs.daying);
      },
      // toDetail(id) {
      //   var routeData =  this.$router.resolve({
      //     query: { type: this.typeName, typeId: this.typeId, articleId: id },
      //   });
      //   window.open(routeData.href, '_blank');
      //   // this.detail(id);
      // },
      toDetail(id, url) {
        var routeData = this.$router.resolve({
          query: { type: this.typeName, typeId: this.typeId, articleId: id },
        });
        if (!url) {
          window.open(routeData.href, "_blank");
        } else {
          var fileName = url.substring(url.lastIndexOf(".") + 1);
          if (["pdf", "doc", "docx"].includes(fileName)) {
            window.open(url);
          } else {
            window.open(routeData.href, "_blank");
          }
        }
  
        // this.detail(id);
      },
      detail(id) {
        getArticle({ id: id }).then((resp) => {
          this.article = resp.data;
          this.checkedIndex(resp.data.type)
          document.title = resp.data.title
          this.qrcode();
        });
        this.contentType = "info";
      },
      checkedIndex(name){
        var index = this.firList.findIndex(el => el.id == name)
        if(index > -1){
          this.firListClick(index)
        }
      },
      downloadView(item) {
        window.open(item.url);
      },
    },
  };
  </script>
  
  <style scoped>
  /* 整体样式 */
  .contentMain {
    
  }
  .contentMain .content {
    width: 1200px;
    margin-top: 30px;
    background: #fff;
    margin: 0 auto;
    padding: 20px;
    text-align: center;
  }
  .contentMain .content .text{
    font-size: 30px;
    margin: -45px 0 130px;

    color: gray;
  }
  
  </style>
  